module.exports = __webpack_public_path__ + "static/media/LPT.ca05336e.svg";